import p, { useCallback as u } from "react";
import { Button as m } from "../button/basic-button.esm.js";
import { ScreenReaderOnly as g } from "../utils/sr-only.esm.js";
import { s as f } from "../pagination.button.module-zVI0JV1c.mjs";
const y = ({
  children: a,
  dataTestId: r = "fuse-pagination",
  isCurrent: e,
  onClick: o,
  href: t
}) => {
  const s = u(
    (n) => {
      if (t && n.preventDefault(), o) {
        const i = Number(a), l = i > 0 ? i : 0;
        o(n, l);
      }
    },
    [o, t, a]
  );
  return /* @__PURE__ */ p.createElement(
    m,
    {
      onClick: s,
      fullWidth: !1,
      variant: "tertiary",
      disabled: e,
      className: `${f.pagination__pageButton} fuse-pagination__page-button`,
      "data-testid": `${r}__page-button`,
      href: t && typeof t == "string" && !e ? t : void 0,
      "aria-current": e ? "page" : void 0
    },
    /* @__PURE__ */ p.createElement(g, null, "Page"),
    " ",
    a
  );
};
export {
  y as PaginationButton
};
